import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { teamApi } from "@/lib/api";
import { usePageMeta } from "@/lib/usePageMeta";

export default function TeamAuth() {
  usePageMeta({ title: "Signing in\u2026 \u2014 SCW Contact Hub", robots: "noindex, nofollow" });
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [err, setErr] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setErr("Missing token."); return; }
    teamApi.auth(token)
      .then(() => nav("/team", { replace: true }))
      .catch((e) => setErr(e?.response?.data?.detail || "This sign-in link is invalid or expired."));
  }, []);  // eslint-disable-line

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#FFFFFF" }}>
      <div style={{ textAlign: "center", padding: 40 }}>
        {!err ? <p style={{ color: "#5C5C5C" }} data-testid="team-auth-loading">Signing you in{"\u2026"}</p>
              : (
                <div data-testid="team-auth-error">
                  <p className="scw-eyebrow" style={{ marginBottom: 8 }}>Sign-in failed</p>
                  <p style={{ fontSize: 18, color: "#5C5C5C", marginBottom: 24 }}>{err}</p>
                  <a href="/team/login" className="scw-btn scw-btn-ghost">Request a new link</a>
                </div>
              )}
      </div>
    </div>
  );
}
